import { get, has, identity, pickBy } from 'lodash'

export function getDefaultHeaders(): object & {
  headers: object
  withCredentials: boolean
  validateStatus: (status: number) => boolean
} {
  return {
    withCredentials: has(global, 'bearertoken'),
    headers: pickBy(
      {
        'X-Customer': global.currentCustomer?.id,
        Accept: 'application/json',
        'Accept-Language': get(global, 'i18n.language', 'de') ?? 'de',
        Authorization: has(global, 'bearertoken')
          ? `Bearer ${get(global, 'bearertoken')}`
          : undefined,
      },
      identity,
    ),
    validateStatus: (status: number): boolean => status >= 200 && status <= 299,
  }
}
